export interface IAccountLogin {
  username: string;
  password: string;
}

export interface IAccountLirn {
  username?: string;
  password?: string;
}

export interface ITuitionForm {
  studentId: string;
  studentName: string;
  name: string;
  paidDate?: string;
}

export interface IExamForm {
  studentId: string;
  studentName: string;
  courseId: string;
  courseName: string;
  moduleId: string;
  moduleName: string;
  status: string;
  pointValue: string;
  value: string;
  credits: string;
}

export interface IDiscussionForm {
  studentId: string;
  studentName: string;
  courseId: string;
  courseName: string;
  discussionId: string;
  discussionName: string;
  gradingPoint: string;
}

export const accountLoginMock: IAccountLogin = {
  username: 'student@gmail.com',
  password: '12345@aA',
};

export const tokenMock: string = 'wrxaz69soaplm1bb5qijbmv6ly2je8';

export const mockDataStudyCourses = {
  id: 1,
  courseName: 'Network Security',
  courseDate: '2025/02/25',
  teacherName: 'Tommy Nolan',
  teacherAvatar: 'https://via.placeholder.com/100',
};

export const mockDataListStudy = [
  {
    id: '1',
    courseDate: '2025-02-20',
    courseName: 'Mathematics 101',
    teacherName: 'Dr. John Doe',
    courseTime: '10:00 AM',
  },
  {
    id: '2',
    courseDate: '2025-02-22',
    courseName: 'Physics 202',
    teacherName: 'Prof. Jane Smith',
    courseTime: '2:00 PM',
  },
  {
    id: '3',
    courseDate: '2025-02-25',
    courseName: 'Chemistry 303',
    teacherName: 'Dr. Albert Brown',
    courseTime: '4:30 PM',
  },
  {
    id: '4',
    courseDate: '2025-02-27',
    courseName: 'Biology 404',
    teacherName: 'Dr. Emily White',
    courseTime: '1:00 PM',
  },
  {
    id: '5',
    courseDate: '2025-03-01',
    courseName: 'History 505',
    teacherName: 'Prof. Michael Green',
    courseTime: '9:30 AM',
  },
  {
    id: '6',
    courseDate: '2025-03-03',
    courseName: 'Computer Science 606',
    teacherName: 'Dr. Susan Black',
    courseTime: '3:45 PM',
  },
];

export const mockDataCourseDetail = {
  courseTitle: 'Computer Science 606',
  studyProgramName: 'Network Security',
  videoUrl:
    'https://firebasestorage.googleapis.com/v0/b/f-green-soul.appspot.com/o/videoplayback.mp4?alt=media&token=595ff145-fd02-4f23-8ffd-195437d6ff39',
  materials: [
    {
      id: 1,
      link: 'https://cdn.slidesharecdn.com/ss_thumbnails/canvaslms-220801231957-fd1cd266-thumbnail.jpg?width=640&height=640&fit=bounds',
    },
    {
      id: 2,
      link: 'https://cdn.slidesharecdn.com/ss_thumbnails/canvaslms-220801231957-fd1cd266-thumbnail.jpg?width=640&height=640&fit=bounds',
    },
    {
      id: 3,
      link: 'https://cdn.slidesharecdn.com/ss_thumbnails/canvaslms-220801231957-fd1cd266-thumbnail.jpg?width=640&height=640&fit=bounds',
    },
  ],
};

export const mockHelpUrl = 'https://mibuniversity.com/resources/';

export const mockDataTuitionFees = [
  { name: 'Tuition Fee - Semester 1', status: 'PAID', date: '01/01/2025' },
  { name: 'Tuition Fee - Semester 2', status: 'UNPAID', date: '' },
  { name: 'Laboratory Fee', status: 'UNPAID', date: '' },
  { name: 'Library Fee', status: 'UNPAID', date: '' },
  { name: 'Sports Facility Fee', status: 'PAID', date: '15/02/2025' },
  { name: 'Technology Fee', status: 'PAID', date: '01/01/2025' },
  { name: 'Student Union Membership Fee', status: 'PAID', date: '01/01/2025' },
  { name: 'Graduation Processing Fee', status: 'PAID', date: '10/03/2025' },
  { name: 'Hostel Fee - Quarter 1', status: 'PAID', date: '05/04/2025' },
  { name: 'Hostel Fee - Quarter 2', status: 'UNPAID', date: '' },
  { name: 'Hostel Fee - Quarter 3', status: 'PAID', date: '01/07/2025' },
  { name: 'Library Late Return Fee', status: 'PAID', date: '20/02/2025' },
  { name: 'Examination Fee', status: 'PAID', date: '01/05/2025' },
  { name: 'Miscellaneous Fee', status: 'UNPAID', date: '' },
];

export const mockDataEducationalProgram = [
  {
    student: 'Alice Johnson',
    course: 'English Composition I',
    module: 'Mathematics',
    points: '90',
    value: 'A',
    status: 'PASSED',
    credit: 120,
  },
  {
    student: 'Bob Smith',
    course: 'English Composition I',
    module: 'Physics',
    points: '45',
    value: 'C',
    status: 'FAILED',
    credit: 50,
  },
  {
    student: 'Charlie Brown',
    course: 'Introduction To Philosophy',
    module: 'Chemistry',
    points: '95',
    value: 'A',
    status: 'PASSED',
    credit: 30,
  },
  {
    student: 'Diana White',
    course: 'Introduction To Philosophy',
    module: 'Biology',
    points: '80',
    value: 'B',
    status: 'PASSED',
    credit: 120,
  },
  {
    student: 'Diana White',
    course: 'Introduction To Philosophy',
    module: 'History',
    points: '45',
    value: 'C',
    status: 'FAILED',
    credit: 120,
  },
];

export const tuitionMockData = [
  { student: 'Emily Johnson', tuition: 'Algebra Fundamentals', date: '12/01/2024' },
  { student: 'Michael Brown', tuition: 'Creative Writing Workshop', date: '01/15/2025' },
  { student: 'Sarah Davis', tuition: 'Physics Lab Sessions', date: '02/05/2025' },
  { student: 'James Wilson', tuition: 'Spanish Language Course', date: '03/01/2025' },
  { student: 'Olivia Smith', tuition: 'History of Art', date: '03/13/2025' },
];

export const mockDataAdministrative = [
  {
    student: 'Alice Johnson',
    course: 'English Composition I',
    module: 'Mathematics',
    points: '85',
    value: 'A',
    status: 'PASSED',
    credit: 120,
  },
  {
    student: 'Bob Smith',
    course: 'English Composition I',
    module: 'Physics',
    points: '40',
    value: 'B',
    status: 'FAILED',
    credit: 50,
  },
  {
    student: 'Charlie Brown',
    course: 'Introduction To Philosophy',
    module: 'Chemistry',
    points: '30',
    value: 'A',
    status: 'FAILED',
    credit: 30,
  },
  {
    student: 'Diana White',
    course: 'Introduction To Philosophy',
    module: 'Biology',
    points: '90',
    value: 'C',
    status: 'PASSED',
    credit: 120,
  },
];
